/* eslint-disable @typescript-eslint/naming-convention */
export function toDataX(
  field: string,
  fieldFormatSettings: FieldFormatSettings
) {
  return `${field} ${JSON.stringify(fieldFormatSettings)}`;
}

export interface FieldFormatSettings {
  ToStringFormat: string;
  Timezone: string;
}
